// extracted by mini-css-extract-plugin
module.exports = {"SecretText":"SecretText_lvKFP"};